"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignetSdk = void 0;
const MessageService_1 = require("./MessageService");
class SignetSdk {
    constructor(option = {}) {
        this.option = option;
        if (typeof window === "undefined")
            throw new Error("SignetSdk can only be used in an iframe of Signet");
        this.messageService = new MessageService_1.MessageService(window.parent, this.option);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.messageService.send("iframe(init)", [], 500);
            }
            catch (e) {
                // send expects a response, but init will not respond anything. This is fine
                return false;
            }
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.messageService.send("iframe(getAccount)", []);
            }
            catch (e) {
                console.error("Failed to get account", e);
                return null;
            }
        });
    }
    send(calldataHex) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.messageService.send("iframe(send)", [calldataHex], 0);
            }
            catch (e) {
                console.error("Failed to send transaction", e);
                return null;
            }
        });
    }
}
exports.SignetSdk = SignetSdk;
